import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/Nippon/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Nippon/frontend/node_modules/next/dist/client/image-component.js");
